import React, { useState } from "react";
import { styled } from '@mui/system';

import Dialog from "@mui/material/Dialog";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from '@mui/material/TextField';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 
import dayjs from "dayjs";

const theme = createTheme();


const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));
const EditVendor = (props) => {
  const [open, setOpen] = React.useState(props.editing);
  const [vendorName, setVendorName] = useState(props.vendorData.vendorName);
  const [vendorContactPerson, setVendorContactPerson] = useState(
    props.vendorData.vendorContactPerson
  );
  const [vendorEmail, setVendorEmail] = useState(props.vendorData.vendorEmail);
  const [vendorSeqId] = useState(props.vendorData.vendorSeqId);
  const [vendorAddress, setVendorAddress] = useState(
    props.vendorData.vendorAddress
  );
  const [vendorGST, setVendorGST] = useState(props.vendorData.vendorGst);
  const [vendorCost, setVendorCost] = useState(props.vendorData.quoteAmount);

  let someDate = props.vendorData.quoteDate;

  if (someDate) {
    var dateCost = someDate.split("/").reverse().join("-");
  }
  const [vendorQuotes, setVendorQuotes] = useState(dateCost);

  const [] = useState();

  const handleClose = () => {
    setOpen(false);
    props.setEditing(false);
  };

  const handleName = (e) => {
    let value = e.target.value;
    setVendorName(value);
    // alert(JSON.stringify(props.vendorData));
    //setValue(props.noOfVendors.vendorsInfo.length);
  };
  const handleEmail = (e) => {
    setVendorEmail(e.target.value);
  };
  const handleContactPerson = (e) => {
    setVendorContactPerson(e.target.value);
  };
  const handleAddress = (e) => {
    setVendorAddress(e.target.value);
  };

  const handleCost = (e) => {
    setVendorCost(e.target.value);
  };
  const handleGST = (e) => {
    setVendorGST(e.target.value);
  };
  const handleQuotes = (e) => {
    setVendorQuotes(e.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: "1.7em" }}>Edit Vendor</p>
        </CustomDialogTitle>

        <CustomDialogTitle dividers>
          <form
            className="form-horizontal "
            style={{ backgroundColor: "#eaf7fdcc" }}
            onSubmit={(event) => {
              event.preventDefault();
              props.editVendorDetails(
                vendorName,
                vendorContactPerson,
                vendorEmail,
                vendorAddress,
                vendorGST,

                vendorCost,
                vendorQuotes,
                vendorSeqId
              );
              setOpen(false);
            }}
          >
            <div className="form-group">
              <div className="col-sm-10">
                <TextField
                  type="text"
                  value={vendorName}
                  className=""
                  disabled
                  id="Startdate"
                  label="Enter vendor name:"
                  onChange={handleName}
                  style={{ border: "none" }}
                  readOnly
                />
              </div>
              <div className="col-sm-10">
                <TextField
                  type="Contact Person"
                  className=""
                  disabled
                  id="Startdate"
                  value={vendorContactPerson}
                  label="Enter contact person name:"
                  onChange={handleContactPerson}
                  style={{ border: "none", marginTop: "5px" }}
                  readOnly
                />
              </div>

              <div className="col-sm-10">
                <TextField
                  type="email"
                  value={vendorEmail}
                  className=""
                  disabled
                  id="Startdate"
                  label="Enter project email:"
                  onChange={handleEmail}
                  style={{ border: "none", marginTop: "5px" }}
                  readOnly
                />
              </div>

              <div className="col-sm-10">
                <TextField
                  multiline
                  type="text"
                  rows={5}
                  value={vendorAddress}
                  className=""
                  disabled
                  id="Startdate"
                  label="Enter address"
                  onChange={handleAddress}
                  style={{ border: "none", marginTop: "5px" }}
                  readOnly
                />
              </div>
              <div className="col-sm-10">
                <TextField
                  type="text"
                  value={vendorGST}
                  className=""
                  id="Startdate"
                  label="GST"
                  onChange={handleGST}
                  style={{ border: "none", marginTop: "5px" }}
                  required
                />
              </div>
              <div class="col-sm-10">
                <TextField
                  type="number"
                  value={vendorCost}
                  className=""
                  id="Startdate"
                  min="0"
                  step="0.01"
                  label="Enter quote cost"
                  onChange={handleCost}
                  style={{ border: "none", marginTop: "5px" }}
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-10">
                <TextField
                  type="date"
                  value={vendorQuotes}
                  className=""
                  id="Startdate"
                  onChange={handleQuotes}
                  InputProps={{ inputProps: { min:dayjs().format("YYYY-MM-DD") } }}
                  label="Propose project complete date"
                  style={{ border: "none" }}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-10">
                <button
                  style={{ marginLeft: "35%", marginTop: "5%" }}
                  onClick={handleClose}
                  type="button"
                  className="btn muted-button  deca-btn-orange a-btn-cancel"
                >
                  Cancel
                </button>

                <button
                  className="btn btn-secondary deca-btn-yellow a-update-email-alert"
                  style={{ marginLeft: "2%", marginTop: "5%" }}
                >
                  Update Vendor Details
                </button>
              </div>
            </div>
          </form>
        </CustomDialogTitle>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default EditVendor;
